import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Geolocation } from '@ionic-native/geolocation';

/*
  Generated class for the GeocodingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GeocodingProvider {
  position: any = null;

  constructor(public http: HttpClient, private geolocation: Geolocation) {
    console.log("Hello GeocodingProvider Provider");
  }

  async resetPosition(){
    this.position = null;
    return await this.getPosition();
  }

  getPosition() {
    console.log("getPosition");
    if(this.position != null){
      return this.position;
    }
    else {
      return this.geolocation
      .getCurrentPosition()
      .then(resp => {
        // resp.coords.latitude
        // resp.coords.longitude
        return this.getAdressFromPosition(resp.coords.latitude,resp.coords.longitude);
      })
      .then(resp => {
        return this.addressToObject(resp);
      })
      .catch(error => {
        console.log("Error getting location", error);
      });

    }
  }

  addressToObject(data){
    this.position = {
      city: data.address.city?data.address.city:data.address.town,
      county: data.address.county,
      state: data.address.state,
      country: data.address.country,
    }
    return this.position;
  }

  getAdressFromPosition(lat,long){

    console.log("getAdressFromPosition");
    return new Promise(resolve => {
      let url = "https://nominatim.openstreetmap.org/reverse?format=json&lat=" + lat + "&lon=" + long + "&zoom=14&addressdetails=1";

      console.log("getAdressFromPosition url :", url);
      this.http.get(url).subscribe(
        data => {
          console.log("getAdressFromPosition data", data);
          resolve(data);
        },
        error => {
          console.log(error.status);
          console.log(error.error); // error message as string
          console.log(error.headers);
        }
      );
    });
  }

  // NOMINATIM API
  // Docs : http://nominatim.org/release-docs/latest/api/Search/
  searchAddress(query) {
    return new Promise(resolve => {
      let url =
        "https://nominatim.openstreetmap.org/search?q=" +
        encodeURI(query) +
        "&format=json&addressdetails=1&countrycodes=fr";

      console.log("searchAddress url :", url);
      this.http.get(url).subscribe(
        data => {
          console.log("searchAddress data", data);
          resolve(data);
        },
        error => {
          console.log(error.status);
          console.log(error.error); // error message as string
          console.log(error.headers);
        }
      );
    });
  }
  // REST API
  // Base query is the search for a place with a string. It returns 20 results matching query word.

  // https://geocoder.tilehosting.com/q/[query].js?key=xRogQtC5Ngo15znlQhAI
  // Reverse geocoding
  // This endpoint transfers a location point (latitude, longitude) to a readable address or place name:

  // https://geocoder.tilehosting.com/r/[longitude]/[latitude].js?key=xRogQtC5Ngo15znlQhAI
  // Country specific search
  // Country specific search for autocomplete. This endpoint returns 20 results matching the within a specific country, identified by the (lowercase ISO 3166 Alpha-2 code).

  // https://geocoder.tilehosting.com/[country_code]/q/[query].js?key=xRogQtC5Ngo15znlQhAI

  // Example
  // For example search for "Zurich" with

  // https://geocoder.tilehosting.com/q/zurich.js?key=xRogQtC5Ngo15znlQhAI

  searchAddressOld(query) {
    return new Promise(resolve => {
      console.log("searchAddress query :", query);
      let url =
        "https://geocoder.tilehosting.com/FR/q/" +
        encodeURI(query) +
        ".js?key=xRogQtC5Ngo15znlQhAI";

      console.log("searchAddress url :", url);
      this.http.get(url).subscribe(
        data => {
          console.log("searchAddress data", data["results"]);
          resolve(data["results"]);
        },
        error => {
          console.log(error.status);
          console.log(error.error); // error message as string
          console.log(error.headers);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/geocoding/geocoding.provider.ts